'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.logRequest = logRequest;
exports.logRequestError = logRequestError;
exports.logResponse = logResponse;
exports.logResponseError = logResponseError;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentName = 'AUTHENTICATION-SDK'; /**
                                           * Copyright(c) 2018, DeCurtis Corporation.All rights reserved.
                                           *
                                           * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
                                           *
                                           * File name: utils.js
                                           * Author   : DeCurtis Team
                                           * Creation Date: 27/9/18 7: 27 PM
                                           *
                                           */

function logRequest(data, errorLog) {
	var logDetail = {
		msgCode: '5001',
		msgName: 'REQUEST',
		msgDetail: (0, _stringify2.default)(data),
		severity: '3'
	};
	errorLog(logDetail, (0, _get2.default)(data, 'headers.common.CorrelationId'), componentName);
}

function logRequestError(data, errorLog) {
	var logDetail = {
		msgCode: '9001',
		msgName: 'REQUEST ERROR',
		msgDetail: (0, _stringify2.default)(data),
		severity: '1'
	};
	errorLog(logDetail, (0, _get2.default)(data, 'headers.common.CorrelationId'), componentName);
}

function logResponse(data, errorLog) {
	var logDetail = {
		msgCode: '5002',
		msgName: 'RESPONSE',
		msgDetail: (0, _stringify2.default)(data),
		severity: '3'
	};
	errorLog(logDetail, (0, _get2.default)(data, 'config.headers.CorrelationId'), componentName);
}

function logResponseError(data, errorLog) {
	var logDetail = {
		msgCode: '9001',
		msgName: 'RESPONSE ERROR',
		msgDetail: (0, _stringify2.default)(data),
		severity: '1'
	};
	errorLog(logDetail, (0, _get2.default)(data, 'config.headers.CorrelationId'), componentName);
}
//# sourceMappingURL=utils.js.map